import { readConfig } from "./config";
import { isHandled, markAsMounted, markAsFailed, findContainers, onReady } from "./dom";
import { debug, error, warn } from "./logger";
export function defineApp(defination) {
    const { name, mountFn: mount, containerId, validateFn: validate, globalName, globalConfigName } = defination;
    const autoBoot = defination.autoBoot !== false;
    function mountElement(el, overrides) {
        if (isHandled(el)) {
            debug(`[${name}] is already mounted.`);
            return false;
        }
        const config = readConfig(name, el, overrides, globalConfigName);
        if (config === null)
            return false;
        if (validate && !validate(config)) {
            error(`[${name}] Configuration is incomplete; the app was not started.`);
            return false;
        }
        markAsMounted(el);
        try {
            mount({ name, el, config });
        }
        catch (mountError) {
            markAsFailed(el);
            error(`[${name}] cannot started`, mountError);
            return false;
        }
        debug(`[${name}] started`);
        return true;
    }
    function mountAll(overrides) {
        const containers = findContainers(name, containerId);
        let mounted = 0;
        containers.forEach(el => {
            if (mountElement(el, overrides)) {
                mounted += 1;
            }
        });
        debug(`${mounted} app was in DOM mounted`);
        return mounted;
    }
    function mountById(id, overrides) {
        const containerId = id.replace("#", "");
        const el = document.getElementById(containerId);
        if (!el) {
            error(`[${name}] container "#${id}" not found.`);
            return false;
        }
        return mountElement(el, overrides);
    }
    function init(arg) {
        if (__DEV__) {
            warn(`[${name}] "${globalName ?? name}.init(...)" is deprecated. Use data-lmu-app + data-config instead.`);
        }
        if (typeof arg === 'string') { // init("LMUcast-playlist")
            mountById(arg);
            return;
        }
        if (arg && typeof arg === 'object') { //init({config, container})            
            const hasWrapperShape = 'config' in arg;
            const wrapper = arg;
            const config = (hasWrapperShape ? wrapper.config : arg);
            if (wrapper.container) {
                mountById(wrapper.container, config);
                return;
            }
            mountAll(config); // init({ config }) - no container
            return;
        }
        mountAll(); // init()
    }
    if (autoBoot) {
        onReady(() => mountAll());
    }
    if (globalName && typeof window !== 'undefined') {
        const target = window;
        const existing = target[globalName] ?? {};
        target[globalName] = { ...existing, init };
    }
    return {
        mountAll: () => mountAll(),
        mountElement,
        init
    };
}
